/**
 * @generated SignedSource<<9811f8fb768ae1cc97daf6c29b640fab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSkuOtherOffers_Product$data = {
  readonly skus: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly offers: {
          readonly " $fragmentSpreads": FragmentRefs<"productSkuOfferConnection_ProductSkuOfferConnection">;
        } | null;
      };
    }>;
  };
  readonly " $fragmentType": "ProductSkuOtherOffers_Product";
};
export type ProductSkuOtherOffers_Product$key = {
  readonly " $data"?: ProductSkuOtherOffers_Product$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuOtherOffers_Product">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "addresses"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuOtherOffers_Product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuConnection",
      "kind": "LinkedField",
      "name": "skus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSku",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "addresses",
                      "variableName": "addresses"
                    }
                  ],
                  "concreteType": "ProductSkuOfferConnection",
                  "kind": "LinkedField",
                  "name": "offers",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "productSkuOfferConnection_ProductSkuOfferConnection",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProductSkuOfferEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ProductSkuOffer",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Seller",
                                  "kind": "LinkedField",
                                  "name": "seller",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "_id",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "deliveryChannel",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Money",
                                  "kind": "LinkedField",
                                  "name": "listPrice",
                                  "plural": false,
                                  "selections": (v0/*: any*/),
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Money",
                                  "kind": "LinkedField",
                                  "name": "netPrice",
                                  "plural": false,
                                  "selections": (v0/*: any*/),
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "priority",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ]
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
})();

(node as any).hash = "f1a91f980fb7542db8c16ff956d109d5";

export default node;
